export default __webpack_public_path__ + "img/euGWnlyt.920de7e4.svg";